import { Platform } from 'alyle-ui/core';
import { Injectable, NgZone, Inject } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { fromEvent } from 'rxjs/observable/fromEvent';
import { merge } from 'rxjs/observable/merge';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
var Responsive = /** @class */ (function () {
    function Responsive(_ngZone, platformId) {
        this._ngZone = _ngZone;
        this.platformId = platformId;
    }
    Responsive.prototype.matchMedia = function (val) {
        return !Platform.isBrowser ? false : matchMedia(val).matches;
    };
    /**
     * return Observable<boolean>
     */
    /**
       * return Observable<boolean>
       */
    Responsive.prototype.observe = /**
       * return Observable<boolean>
       */
    function (value) {
        var _this = this;
        var mm = this.matchMedia(value);
        var mediaObservable = merge(Observable.of(true), this.stateView());
        return mediaObservable
            .filter(function (state) {
            return _this.matchMedia(value) !== mm || state === true;
        })
            .map(function () {
            mm = _this.matchMedia(value);
            _this._registerMedia(value);
            return _this.matchMedia(value);
        });
    };
    Responsive.prototype._registerMedia = function (value) {
        Responsive._queryMap.set(value, this.matchMedia(value));
    };
    Responsive.prototype.stateView = function () {
        if (isPlatformBrowser(this.platformId)) {
            return this._ngZone.runOutsideAngular(function () {
                return fromEvent(window, 'resize');
            });
        }
        if (isPlatformServer(this.platformId)) {
            return Observable.of();
        }
    };
    Responsive._queryMap = new Map();
    Responsive.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    Responsive.ctorParameters = function () { return [
        { type: NgZone, },
        { type: Object, decorators: [{ type: Inject, args: [PLATFORM_ID,] },] },
    ]; };
    return Responsive;
}());
export { Responsive };
//# sourceMappingURL=media.service.js.map